<script lang="ts">
	//Components
	import SelectList from '../../../../../../../SelectList/SelectList.svelte';
	//Store
	import { readDeviceStatus, readDeviceSettings, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
import { rooms } from 'src/stores/lists/rooms';

	//Services
	import { format } from 'svelte-i18n';
	//Helpers
	import { selectDevicesByRoom } from '../../../../GenericComponents/helpers';
	import {
		navigateToShop,
		generateWhenAndDoMissingDevices,
		sortByPosition,
	} from '../../../../../../../Lists/list-helpers';
	import {
		excludedCategoriesFromWhenConditions,
		excludedDeviceTypesFromWhenConditions,
	} from '../../../../../../helpers/init_device_conditions';
	import {
		celsius_to_fahrenheit,
		createDeviceID,
		isCameraDevice,
		isWallDisplay,
		real_id,
		isCctOnlyDevice,
	} from '../../../../../../../../helpers/interface_helpers';
	import { CAMERA_COND_NAMES } from './helpers/camera-scene-helpers';
	import { CAMERA_MODE_MOTION_ZONES } from 'src/components/Scenes/helpers/device_conditions/custom_cases/camera/camera-device-helpers';
	import {
		_init_conditions_components,
		format_title,
		selectDeviceConditions,
	} from './helpers/common-helpers';
	import {
		getPresenceEditBootstrapKey,
		shouldUsePresenceEditBootstrap,
	} from './helpers/presence-helpers';
	import { _deepClone, capFirstChar } from 'src/helpers/utilities';
	import { get } from 'svelte/store';
	import { isPresenceDevice } from 'src/components/Scenes/helpers/device_conditions/custom_cases/presence/presence-device-helpers';
	//Types
	import type { DeviceConditionUI } from '../../../../../../../../types/DeviceCondAndTriggerUI';
	import {
		is_device_cond_ui,
		is_device_trigger_ui,
	} from '../../../../../../../../types/DeviceCondAndTriggerUI';
	import { WHEN_WIZARD_STEPS_INDEXES } from '../../helpers/when-wizard-helpers';
	import { defaultDeviceCondition } from '../../helpers/when-wizard-helpers';
	import { CCT_ONLY_DEVICES } from 'src/constants';
	import { normalizeDeviceChannelForCondition } from '../../../../../../helpers/device_channel_condition_helpers';
	import {
		accessibleVirtualDevice,
		accessibleVirtualDevices,
		isFirstVirtualDevice,
	} from 'src/helpers/virtual_helpers/virtual_components_helpers';
	import type { Device } from 'src/types/Device';
	import { Alert, Button } from '@Shelly/shelly-design-system/index';
	import { push } from 'svelte-spa-router';
	import { defaultHiddenDevicesRoom } from 'src/helpers/constants';
	import { isTestUser } from 'src/helpers/user_helpers';
	import { resetDrawerClose } from 'src/helpers/drawer_helpers';
	import EmptyList from 'src/components/Lists/EmptyList.svelte';
	export let sceneData: any;
	export let firstSelectedRef: HTMLElement = null;

	const exclude_categories = excludedCategoriesFromWhenConditions;
	const exclude_types = excludedDeviceTypesFromWhenConditions;
	const exclude_shared = true;
	const include_types = CCT_ONLY_DEVICES;
	let missingDevice: {
		title: string;
		value: string | undefined;
		id: string;
	} = null;

	// ── S4SN presence only: reactive re-bootstrap when zone settings / device store arrive later
	let suppressPresenceEditBootstrap = false;
	let lastPresenceEditBootstrapKey = '';

	const handle_device_and_find_cond_options = () => {
		sceneData.components = [];
		sceneData.devicePropsOptions = [];

		//on device change first reset selected condition
		// OLD IMPLEMENTATION
		// selectedCondition.title = $format('label_select_device_property');
		// selectedCondition.value = undefined;

		sceneData.selectedDeviceProp = {};
		//then reset the temporary object we store the data
		// TODO create constat with default values for device_condition and use it in WhenStep.svelte and here
		sceneData._device_condition = defaultDeviceCondition;

		//if the device is not selected, clean whole data ;
		if (sceneData.selectedDevice.value !== undefined) {
			sceneData.selectedDevice.value = sceneData.selectedDevice.value + '';

			const device = $devices[real_id(sceneData.selectedDevice.value)];
			let channel = sceneData.selectedDevice?.value?.split('_')[1] || '0';

			// Normalize channel for presence sensors - zone codes should map to channel 0
			if (device?.type === 'S4SN-0U61X' && Number(channel) >= 4200) {
				channel = '0';
			}

			sceneData._device_condition.device = {
				id: real_id(sceneData.selectedDevice.value),
				channel: channel,
			};

			sceneData.components = _init_conditions_components(
				$devices[sceneData.selectedDevice.value],
				readDeviceStatus(real_id(sceneData.selectedDevice.value)),
				readDeviceSettings(real_id(sceneData.selectedDevice.value)),
			);

			sceneData.devicePropsOptions = selectDeviceConditions(sceneData.components);
		}

		console.log('DeviceStep: Scene Data', sceneData);
	};

	// Multiple Virtual devices (more than 1) is a premium feature
	// If basic user has more than 1 virtual device, the rest of them will be disabled
	const prepareVirtualDeviceInList = (device: Device, deviceSelected) => {
		let selected = device.id === deviceSelected?.id;

		let disabledVirtualDevice = !accessibleVirtualDevice(device);
		if (selected && disabledVirtualDevice) {
			//Disable Scene  Edit button for disabled virtual devices
			sceneData.isValid = false;
			sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.DEVICE_STEP;
		}
		return {
			...device,
			disabled: disabledVirtualDevice,
			badge: !isFirstVirtualDevice(device)
				? $format('label_premium', { default: 'Premium' })
				: undefined,
		};
	};

	const mapRoomDevicesSelectedProp = (room, deviceSelected) => {
		const updatedCards = room.cards.map((device) => {
			let device_item = device;
			if (device.category === 'virtual_device') {
				device_item = prepareVirtualDeviceInList(device, deviceSelected);
			}
			return {
				...device_item,
				selected: device.id === deviceSelected?.id,
			};
		});

		return {
			...room,
			cards: updatedCards,
		};
	};

	const validateWizardStepSelectDevice = () => {
		sceneData.isValid = false;
		sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.DEVICE_PROPS_STEP;
	};

	const onSelectDevice = (device) => {
		if (isPresenceDevice(device.id, get(devices))) {
			suppressPresenceEditBootstrap = true;
		}
		validateWizardStepSelectDevice();

		sceneData.selectedDevice = {
			...device,
			selected: true,
		};

		sortedRoomsWithDevices = sortedRoomsWithDevices.map((room) => {
			return mapRoomDevicesSelectedProp(room, device);
		});

		handle_device_and_find_cond_options();
	};

	/** if we edit conditions
	 * 1.first check if the incomming object is a device trigger or device condition
	 * 2. Because we are using device condition as based type (to avoid to much typesafe checks)
	 * we need to find out if it is a trigger and remove additional info for trigger type
	 * (it is a separate variable)
	 */

	// if (is_device_trigger_ui(sceneData.translated))
	// 	delete sceneData.translated.cond_type;
	$: {
		if (
			sceneData.when_info.mode === 'edit' &&
			(Object.keys(sceneData.selectedDevice).length === 0 ||
				!$devices[sceneData._device_condition?.device?.id])
		) {
			sceneData.isValid = false;
			sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.DEVICE_STEP;
		}
	}

	/** Same as the edit `if` below, but zone `add_info_ind` may be string vs number — normalize for S4SN. */
	function runPresenceEditDeviceBootstrap() {
		sceneData._device_condition = _deepClone(sceneData.translated) as DeviceConditionUI;

		const baseId = real_id(sceneData._device_condition?.device?.id ?? '');
		const _device = $devices?.[baseId];

		let deviceChannel = Number(sceneData._device_condition?.device?.channel);
		deviceChannel = normalizeDeviceChannelForCondition({
			deviceType: _device?.type,
			deviceChannel,
			condName: sceneData._device_condition?.cond_name ?? sceneData.translated?.cond_name,
		});

		const dev_id = createDeviceID(baseId, deviceChannel, _device?.type);
		const device = $devices[dev_id] ?? $devices[baseId];

		if (typeof device !== 'undefined') {
			missingDevice = null;
			sceneData.selectedDevice = {
				title: device.name || 'unknown device',
				value: device?.id ?? dev_id,
				id: device?.id ?? dev_id,
			};

			sceneData.components = _init_conditions_components(
				device,
				readDeviceStatus(real_id(sceneData.selectedDevice.value)),
				readDeviceSettings(real_id(sceneData.selectedDevice.value)),
			);
		} else {
			missingDevice = {
				title: dev_id,
				value: dev_id || undefined,
				id: dev_id,
			};

			sceneData.selectedDevice = { ...missingDevice };
		}

		sceneData.devicePropsOptions = selectDeviceConditions(sceneData.components);

		const active_condition = sceneData.components.find((el) => {
			if (el.props.id === sceneData._device_condition.cond_name) {
				if (typeof sceneData._device_condition.add_info_ind !== 'undefined') {
					return (
						String(sceneData._device_condition.add_info_ind) ===
						String(el.props.add_info_ind)
					);
				}
				if (typeof sceneData._device_condition.input_index !== 'undefined') {
					return sceneData._device_condition.input_index === el.props.input_index;
				}

				return (
					typeof el.props.add_info_ind === 'undefined' &&
					typeof el.props.input_index === 'undefined'
				);
			}

			return false;
		});

		if (active_condition?.props?.type !== 'virtual_component') {
			if (active_condition?.props?.character?.match(/F/)) {
				sceneData._device_condition.value = celsius_to_fahrenheit(
					Number(sceneData._device_condition.value),
				).toString();
			}
		}

		sceneData.selectedDeviceProp = {
			title: format_title(active_condition) || 'unknown',
			value:
				typeof active_condition?.props?.add_info_ind !== 'undefined'
					? `${active_condition?.props?.id}${active_condition?.props?.add_info_ind}`
					: typeof active_condition?.props?.input_index !== 'undefined'
						? `${active_condition?.props?.id}${active_condition?.props?.input_index}`
						: active_condition?.props?.id,
		};

		if (import.meta.env.DEV) {
			console.log(
				'DeviceStep: presence selectedDeviceProp, active:',
				sceneData.selectedDeviceProp,
				active_condition,
			);
		}
	}

	if (
		sceneData.when_info?.mode === 'edit' &&
		(is_device_cond_ui(sceneData.translated) || is_device_trigger_ui(sceneData.translated)) &&
		!shouldUsePresenceEditBootstrap(
			sceneData.translated,
			get(devices),
			readDeviceSettings(real_id(sceneData.translated?.device?.id ?? '')),
		)
	) {
		//update the temporary object with the edited and if need delete cond_type key
		sceneData._device_condition = _deepClone(sceneData.translated) as DeviceConditionUI;

		const baseId = real_id(sceneData._device_condition?.device?.id ?? '');
		const _device = $devices?.[baseId];

		let deviceChannel = Number(sceneData._device_condition?.device?.channel);
		deviceChannel = normalizeDeviceChannelForCondition({
			deviceType: _device?.type,
			deviceChannel,
			condName: sceneData._device_condition?.cond_name ?? sceneData.translated?.cond_name,
		});

		const dev_id = createDeviceID(baseId, deviceChannel, _device?.type);
		const device = $devices[dev_id] ?? $devices[baseId];

		//update selected device and pass it to the child component (main device only)
		if (typeof device !== 'undefined') {
			sceneData.selectedDevice = {
				title: device.name || 'unknown device',
				value: device?.id ?? dev_id,
				id: device?.id ?? dev_id,
			};

			//find the all options for this device
			sceneData.components = _init_conditions_components(
				device,
				readDeviceStatus(real_id(sceneData.selectedDevice.value)),
				readDeviceSettings(real_id(sceneData.selectedDevice.value)),
			);
		} else {
			missingDevice = {
				title: dev_id,
				value: dev_id || undefined,
				id: dev_id,
			};

			sceneData.selectedDevice = { ...missingDevice };
		}

		//format above options for select holder
		sceneData.devicePropsOptions = selectDeviceConditions(sceneData.components);

		//find actual condition for the device from translated data
		//TODO: need refactor
		let active_condition = sceneData.components.find((el) => {
			if (el.props.id === sceneData._device_condition.cond_name) {
				if (typeof sceneData._device_condition.add_info_ind !== 'undefined') {
					return sceneData._device_condition.add_info_ind === el.props.add_info_ind;
				}
				if (typeof sceneData._device_condition.input_index !== 'undefined') {
					return sceneData._device_condition.input_index === el.props.input_index;
				}

				return (
					typeof el.props.add_info_ind === 'undefined' &&
					typeof el.props.input_index === 'undefined'
				);
			}

			return false;
		});

		//NOTE: This introduces bugs, not all the time is needed.
		// E.g. skip for Virtual Components
		//if the condition "character" is in fahrenheit, convert the value to celsius
		if (active_condition?.props?.type !== 'virtual_component') {
			if (active_condition?.props?.character?.match(/F/)) {
				sceneData._device_condition.value = celsius_to_fahrenheit(
					Number(sceneData._device_condition.value),
				).toString();
			}
		}

		//update selected condition with actual
		sceneData.selectedDeviceProp = {
			title: format_title(active_condition) || 'unknown',
			value:
				typeof active_condition?.props?.add_info_ind !== 'undefined'
					? `${active_condition?.props?.id}${active_condition?.props?.add_info_ind}`
					: typeof active_condition?.props?.input_index !== 'undefined'
						? `${active_condition?.props?.id}${active_condition?.props?.input_index}`
						: active_condition?.props?.id,
		};

		if (
			isCameraDevice(device) &&
			sceneData._device_condition?.cond_name === CAMERA_COND_NAMES.ZONE_MOTION
		) {
			sceneData.selectedDeviceProp = {
				title: $format('camera_motion_zones', { default: 'Motion zones' }),
				value: CAMERA_MODE_MOTION_ZONES,
			};
		}

		if (import.meta.env.DEV) {
			console.log(
				'DeviceStep: selectedDeviceProp, active:',
				sceneData.selectedDeviceProp,
				active_condition,
			);
		}
	}

	$: presenceBootstrapDeviceId = sceneData.translated?.device?.id
		? real_id(sceneData.translated.device.id)
		: undefined;
	$: presenceBootstrapSettingsStore = getDeviceSettings(presenceBootstrapDeviceId);
	$: presenceBootstrapSettings = $presenceBootstrapSettingsStore;

	$: if (
		!suppressPresenceEditBootstrap &&
		sceneData.when_info?.mode === 'edit' &&
		(is_device_cond_ui(sceneData.translated) || is_device_trigger_ui(sceneData.translated)) &&
		shouldUsePresenceEditBootstrap(sceneData.translated, $devices, presenceBootstrapSettings)
	) {
		const bootstrapKey = getPresenceEditBootstrapKey(
			sceneData.translated,
			$devices,
			presenceBootstrapSettings,
		);
		if (bootstrapKey !== lastPresenceEditBootstrapKey) {
			lastPresenceEditBootstrapKey = bootstrapKey;
			runPresenceEditDeviceBootstrap();
		}
	}

	$: sortedRoomsWithDevices = Object.values({
		...$rooms,
		...(isTestUser() && {
			[defaultHiddenDevicesRoom.value as number]: {
				name: $format(defaultHiddenDevicesRoom.title, {
					default: defaultHiddenDevicesRoom.translationDefault,
				}),
				id: defaultHiddenDevicesRoom.value,
			},
		}),
	})
		.sort(sortByPosition)
		.map((room: any) => {
			return { title: room.name, value: room.id };
		})
		.map((room) => {
			return {
				cards: selectDevicesByRoom(
					$devices,
					room,
					exclude_categories,
					exclude_types,
					exclude_shared,
					true, // only_cloud_connected
					include_types,
				)
					.filter((device) => {
						const _device = $devices?.[device.id];
						if (device.category === 'module') {
							/**
							 * CCT-only devices (like S3MX) should be included as they support conditions
							 */
							if (isCctOnlyDevice(_device?.type)) {
								return true;
							}
							/**
							 * module in 'shell' mode doesn't have components to be used in conditions
							 */
							return !/^(shell)$/.test($devices[device.id].mode);
						}
						/**
						 * hiding channels from scenes because they are write only, not readable at the moment
						 */
						return !(isWallDisplay(_device.type) && device.category !== 'relay');
					})
					.sort(sortByPosition),
				roomID: room.value,
				roomName: room.title,
			};
		})
		.filter((room) => {
			return room.cards.length > 0;
		})
		.map((room) => {
			return mapRoomDevicesSelectedProp(room, sceneData.selectedDevice);
		});

	$: if (missingDevice?.title) {
		const missing_devices = generateWhenAndDoMissingDevices(missingDevice);

		sortedRoomsWithDevices = [{ ...missing_devices }, ...sortedRoomsWithDevices];
	}
</script>

{#if !accessibleVirtualDevices()}
	<Alert
		class="mb-m mt-m"
		type="info"
		customIcon="fas fa-gem icon-premium-color"
		heading={$format('alert_title_unlock_virtual_devices_scenes', {
			default: 'Multiple Virtual Devices is a Premium feature. Upgrade to Premium to unlock.',
		})}
	>
		<Button
			slot="bottom"
			variant="premium"
			size="m"
			width="auto"
			on:click={() => {
				resetDrawerClose();
				push('/settings/premium');
			}}
		>
			{capFirstChar(
				$format('button_get_premium', {
					default: 'Get Premium',
				}),
			)}
		</Button>
	</Alert>
{/if}
<SelectList
	missingDevicesAlertHeading={$format('missing_devices_alert_label', {
		values: {
			type: $format('label_condition', { default: 'condition' }).toLowerCase(),
		},
		default: 'You have missing device(s) in this {type}.',
	})}
	class="mb-s"
	title={$format('label_select_device', {
		default: 'Select device',
	})}
	list={sortedRoomsWithDevices}
	variant="radio"
	selectedCardsId={[sceneData.selectedDevice]}
	on:click={(e) => onSelectDevice(e.detail)}
	bind:firstSelectedRef
/>

{#if !sortedRoomsWithDevices.length}
	<div class="d-flex flex-direction-column justify-content-center align-items-center mt-s">
		<EmptyList
			withoutMargin
			type="modal"
			title={$format('on_board_get_device_title', {
				default: 'Get the necessary devices to set up.',
			})}
			description={$format('on_board_get_device_description', {
				default:
					'Currently you don’t have the necessary devices. Please get the necessary devices to set up your automations.',
			})}
			btnText={capFirstChar(
				$format('button_go_to_store', {
					default: 'Go to store',
				}).toLocaleLowerCase(),
			)}
			onClick={() => {
				navigateToShop();
			}}
		/>
	</div>
{/if}
